import React from "react"
import {useNavigate} from "react-router-dom"
import {toast} from "react-toastify"
import {errorMessage} from "utils/utils"
import swal from "sweetalert"
import Spinner from "components/Spinner"
import "./RescueButtons.css"


export default function RescueButtons(props) {

    const {rescue, submit} = props
    const navigate = useNavigate()

    const improve = () => {
        rescue.improve()
    }
    
    const save = () => {
        const toaster = toast.loading("Snimanje...")
        rescue.save(response => {
            toast.update(toaster, {render: "Snimljeno", type: "success", isLoading: false, autoClose: 2500})
            navigate('/')
        }, response => {
            console.log("111", response)
            toast.update(toaster, {render: `Neka greška [3]: ${errorMessage(response)}`, type: "error", isLoading: false, autoClose: 2500})
        })
    }
    
    const discard = () => {
        rescue.reload()
        navigate('/')
    }
    
    const erase = () => {
        const resp = window.prompt("Ako stvarno želite da obrišete povrednu listu, upišite 'brisanje'.")
        if (resp?.toLowerCase() === 'brisanje') {
            const toaster = toast.loading("Brisanje...")
            rescue.erase(reponse => {
                toast.update(toaster, {render: "Obrisano", type: "success", isLoading: false, autoClose: 2500})
                navigate('/')
            }, response => {
                toast.update(toaster, {render: `Neka greška [4]: ${errorMessage(response)}`, type: "error", isLoading: false, autoClose: 2500})
            })
        }
        else {
            swal("Povredna lista nije obrisana", "Reč nije ispravno uneta", "error")
        }
    }

    const trySubmit = () => {
        if (!rescue.permissions.submit) {
            swal("Ne možeš zaključiti listu", "Nemaš overenu licencu. Prebaci povrednu listu spasiocu koji je bio sa tobom.", "warning")
            return
        }
        submit()
    }

    const unsubmit = () => {
        if (!window.confirm("Otključavanje povredne liste?")) return
        rescue.unsubmit(() => rescue.refetch())
    }
    
    const download = () => {
        const toaster = toast.loading("Priprema se PDF...")
       	if (rescue.permissions.save && rescue.dirty) {
           	rescue.save(response => {
               	console.log("Snimljeno", response)
               	rescue.download(
                   	response => { toast.dismiss(toaster) },
                   	response => {
                       	toast.update(toaster, {render: `Neka greška [5]: ${errorMessage(response)}`, type: "error", isLoading: false, autoClose: 2500})
                    }
                )
           	}, response => { 
               	toast.update(toaster, {render: `Neka greška [6]: ${errorMessage(response)}`, type: "error", isLoading: false, autoClose: 2500})
           	})
       	}
       	else {
           	rescue.download(
               	response => { toast.dismiss(toaster) },
               	response => { toast.update(toaster, {render: `Neka greška [7]: ${errorMessage(response)}`, type: "error", isLoading: false, autoClose: 2500}) }
            )
       	}
    }


    return <section id="rescue-buttons">
        {rescue.isLoading && <Spinner/>}
        
        <div id="button-columns">        
            <div className="buttons">
                {rescue.permissions.save && <button className="btn btn-outline-primary" onClick={improve}><i className="fas fa-wand-magic-sparkles"/><span>Sredi</span></button>}
                {rescue.permissions.unsubmit && <button className="btn btn-outline-primary" onClick={unsubmit}><i className="fas fa-unlock"/><span>Otključaj</span></button>}
                {rescue.permissions.download && <button className="btn btn-outline-primary" onClick={download}><i className="fas fa-file-pdf"/><span>Skini PDF</span></button>}
                {rescue.permissions.save && <button className="btn btn-outline-danger" onClick={discard}><i className="fa-solid fa-rotate-left"/><span>Odbaci izmene</span></button>}
                {rescue.permissions.delete && <button className="btn btn-danger" onClick={erase}><i className="fas fa-trash-alt"/><span>Obriši</span></button>}
            </div>
            <div className="buttons">
                {rescue.permissions.save && <button className="btn btn-primary" disabled={rescue.isSaving} onClick={save}><i className="fas fa-cloud-upload-alt"/><span>Snimi</span></button>}
                {rescue.permissions.save && <button className="btn btn-primary" style={!rescue.permissions.submit ? {opacity: 0.65} : undefined} disabled={rescue.isSaving} id="submit" onClick={trySubmit}><i className="fas fa-lock"/><span>Zaključi</span></button>}
            </div>
        </div>
    </section>
}
